import apiClient, { unwrapData } from "./apiClient";

export async function getAiConfigs(params = {}, options = {}) {
  const response = await apiClient.get("/api/ai-configs", {
    ...options,
    query: {
      page: params.page,
      limit: params.limit,
    },
  });
  const data = unwrapData(response) || {};

  return {
    items: Array.isArray(data.items) ? data.items : [],
    meta: response?.meta || {},
  };
}

export async function getAiConfig(configId, options = {}) {
  const response = await apiClient.get(`/api/ai-configs/${encodeURIComponent(configId)}`, options);
  return unwrapData(response);
}

export async function createAiConfig(payload = {}, options = {}) {
  const response = await apiClient.post("/api/ai-configs", {
    ...options,
    body: payload,
  });
  return unwrapData(response);
}

export async function updateAiConfig(configId, payload = {}, options = {}) {
  const response = await apiClient.put(`/api/ai-configs/${encodeURIComponent(configId)}`, {
    ...options,
    body: payload,
  });
  return unwrapData(response);
}

export async function deleteAiConfig(configId, options = {}) {
  const response = await apiClient.del(`/api/ai-configs/${encodeURIComponent(configId)}`, options);
  return unwrapData(response);
}

export async function getClients(options = {}) {
  const response = await apiClient.get("/api/clients", options);
  const data = unwrapData(response) || {};
  return Array.isArray(data.items) ? data.items : [];
}
